var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("タグ一覧")]),_c('v-card-text',[_vm._v(" 編集するタグを選択してください。 "),_c('v-divider'),_c('tag-info-list',{attrs:{"tags":_vm.getBindTags,"link":"admin/tags"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }